import type { FC } from "react";
import { useCallback, useState } from "react";

import { useTranslations } from "@ui/providers/useTranslations";
import classNames from "classnames";

import { UiLogoutIcon } from "@jti/brand-icons/ui-logout";
import { Button } from "@jti/core-components/components/Button";
import { liveChat } from "@jti/fe-clients";

import styles from "./SignOut.module.scss";

export type SignOutProps = {
  logout(): Promise<boolean>;
  className?: string;
};

export const SignOut: FC<SignOutProps> = ({ logout, className }) => {
  const { __ } = useTranslations();
  const [disableLogout, setDisableLogout] = useState(false);

  const logoutHandler = useCallback(() => {
    setDisableLogout(true);

    logout().finally(() => {
      setDisableLogout(false);
      liveChat.onLogout();
    });
  }, [logout]);

  return (
    <Button
      variant="secondary"
      onClick={logoutHandler}
      disabled={disableLogout}
      size="lg"
      data-testid="signOutButton"
      className={classNames(styles.button, className)}
      iconBefore={UiLogoutIcon}
    >
      {__("libs.ui.sign_out")}
    </Button>
  );
};
